export const ALLOWED_IMAGE_TYPES = [
  "image/jpeg",
  "image/png",
  "image/gif",
  "application/pdf",
];

export const ALLOWED_PDF_TYPES = ["application/pdf"];

export const MAX_FILE_SIZE_IMAGE_KB = 2050; // ~2MB
export const MAX_FILE_SIZE_PDF_KB = 5120; // 5MB

export const REGISTER_AS_OPTIONS = [
  { value: "Lead Aggregator", label: "Lead Aggregator" },
  { value: "DSA-Company", label: "DSA-Company" },
  { value: "DSA-Individual", label: "DSA-Individual" },
  { value: "DSA-With-GST", label: "DSA With GST" },
  { value: "DSA-Without-GST", label: "DSA Without GST" },
];

export const YES_NO_OPTIONS = [
  { value: "Yes", label: "Yes" },
  { value: "No", label: "No" },
];

export const EMPLOYEE_COUNT_OPTIONS = [
  { value: "1-5", label: "1-5" },
  { value: "5-10", label: "5-10" },
  { value: "10+", label: "10+" },
];

export const BUSINESS_VINTAGE_OPTIONS = [
  { value: "Below 1 year", label: "Below 1 year" },
  { value: "1-3yr", label: "1-3yr" },
  { value: "above 3 year", label: "above 3 year" },
];

// Registration paths that don't require a GST number.
export const GST_EXEMPT_REGISTER_AS = ["DSA-Individual", "DSA-Without-GST"];
